type PayloadError = {
  error: {
    status: number;
    data: {
      statusCode: number;
      message: string;
    };
  };
  meta: Record<string, unknown>;
};

export const isNumber = (value: unknown): value is number => typeof value === "number";
export const isArray = (value: unknown): value is unknown[] => Array.isArray(value);
export const isObject = (value: unknown): value is Record<string, unknown> => typeof value === "object" && value !== null && !isArray(value);
export const isFunction = (p: unknown): p is (...args: never[]) => never => typeof p === "function";
export const isPayloadErrorWithMessage = (payload: unknown): payload is PayloadError =>
  isObject(payload) &&
  "error" in payload &&
  isObject(payload.error) &&
  "data" in payload.error &&
  isObject(payload.error.data) &&
  "message" in payload.error.data &&
  typeof payload.error.data.message === "string";

export const isStatusCode409 = (payload: unknown): payload is PayloadError =>
  isObject(payload) && isObject(payload.error) && isObject(payload.error.data) && isNumber(payload.error.status) && payload.error.status === 409;
export const isStatusCode401 = (payload: unknown): payload is PayloadError =>
  isObject(payload) && isObject(payload.error) && isObject(payload.error.data) && isNumber(payload.error.status) && payload.error.status === 401;
